module.exports = __webpack_public_path__ + "static/media/toll-holdings.d4c1ac27.svg";